var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app_header",staticStyle:{"background-color":"var(--dark)"}},[_c('nav',_vm._l((this.$router.options.routes),function(route,index){return _c('router-link',{key:index,attrs:{"to":route.path}},[_vm._v(_vm._s(route.name))])}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }